<!-- <div class="back-overlay">
</div> -->
<div class="offer-bottom-popup-view">
  <ion-card style="height:95vh;overflow: scroll;">
    <ion-card-header>
          <ion-card-subtitle>
            <!-- <span class="ion-text-center">
              Special <span style="color: #01A3A4;">Offer</span>
              <ion-icon name="close-outline" (click)="close(false)" style="right: 0;position: absolute;font-size: 2rem;color: #01A3A4;">
              </ion-icon>
            </span> -->

            <img src="./assets/img/premium-crown-cross.svg" class="prermium-crow-icon">
            <ion-icon name="close-outline" (click)="close(false)" class="close-btn">
            </ion-icon>
            <ion-row>
              <ion-col>
                <h3 class="first-text">Go Premium, Get Faster Result</h3>
                <p class="second-text">Premium member are 70% more likely to reach their <b>weight loss goal</b>.</p>
              </ion-col>
            </ion-row>

            <!-- <span class="ion-text-center" *ngIf="country == 'IND'">
              Festival <span style="color: #01A3A4;">Offer</span><ion-icon name="close-outline" (click)="close(false)" style="right: 0;
              position: absolute;font-size: 2rem;color: #01A3A4;"></ion-icon>
            </span> -->
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      

      <!-- <ion-row class="padding-top-bottom" style="padding-top: 20px;">
        <ion-col class="ion-text-left green-msg"> -->
          <!-- - <b>100% refund in 3 Months,</b> if you follow* it and does not loose even 5 Kg in 3 months -->
          <!-- <b>{{data.message0}} *</b>
        </ion-col>
      </ion-row> -->

      <ion-row>
        <ion-col class="ion-text-center green-msg">
          <img style="height: 25vh;margin-top: -25px;" src="./assets/img/Treasure.gif">
          <!-- <img style="height: 18vh;margin-top: -25px;" src="./assets/img/diwali-offer.png" *ngIf="country == 'IND'"> -->
        </ion-col>
      </ion-row>

      <ion-row class="ion-text-center"> 
        <!-- <ion-col size="2" class="ion-text-center logo">
          <div>
            <img src="./assets/img/gift.gif">
          </div>
        </ion-col> -->
        <ion-col class="content-header" *ngIf="country == 'IND'">
          <!-- <ion-row class="content-header"> -->
            <!-- <ion-col class="ion-text-left"> -->
              {{data.perid}} Months Plan <span class="color-gold">₹</span><span class="strike">{{data.amount}}</span><span class="color-gold"> {{data.discountedAmount}}</span>
            <!-- </ion-col> -->
          <!-- </ion-row> -->
        </ion-col>
        <ion-col class="content-header" *ngIf="country != 'IND'">
          <!-- <ion-row class="content-header"> -->
            <!-- <ion-col class="ion-text-left"> -->
              {{data.perid}} Months Plan <span class="color-gold">$</span> <span class="strike">{{data.message4}}</span><span class="color-gold"> {{data.dollarPrice}}</span>
            <!-- </ion-col> -->
          <!-- </ion-row> -->
        </ion-col>
      </ion-row>

      
      <!-- <ion-row *ngIf="!isIOSDevice">
        <ion-col class="ion-text-center green-msg">
          <img style="height: 50px;" src="./assets/img/refund.jpg"  style="height: 12vh;">
        </ion-col>
      </ion-row>

      <ion-row *ngIf="isIOSDevice">
        <ion-col class="ion-text-center green-msg">
          <img style="height: 50px;" src="./assets/img/pizza.jpeg"  style="height: 12vh;">
        </ion-col>
      </ion-row> -->

      <!-- <ion-row class="padding-top-bottom">
        <ion-col class="ion-text-left green-msg">
          - <b [innerHTML]="data.message1"></b>
        </ion-col>
      </ion-row> -->
      <ion-row class="padding-top-bottom ion-text-center" style="padding: 10px 10px;">
        <ion-col class="start-transform-text">
          <b style="font-size: 1.2rem;color: #a5a6aa;">Be {{profileData.suggestedWeight}} {{unit}} by {{profileData.dateBy}}</b>
        </ion-col>
      </ion-row>

      <ion-row class="padding-top-bottom ion-text-center" style="padding: 0px 10px;" *ngIf="freeTrialEndDateDiff == 0">
        <ion-col class="start-transform-text">
          <span style="font-size: 0.9rem;color: #a5a6aa;">Special Offer valid only for today</span>
        </ion-col>
      </ion-row>

      <ion-row class="padding-top-bottom ion-text-center" style="padding: 0px 10px;" *ngIf="freeTrialEndDateDiff > 0">
        <ion-col class="start-transform-text">
          <span style="font-size: 0.9rem;color: #a5a6aa;">Special offer expires in {{freeTrialEndDateDiff}} days</span>
        </ion-col>
      </ion-row>

      <!-- <ion-row class="padding-top-bottom" *ngIf="!isIOSDevice" style="padding: 0px 10px;">
        <ion-col class="ion-text-left start-transform-text">
          <span [innerHTML]="data.message1" style="font-size: 1rem;"></span><span><b style="font-size: 1rem;"> {{profileData.suggestedWeight}} Kgs by {{profileData.dateBy}}</b></span>
        </ion-col>
      </ion-row>

      <ion-row class="padding-top-bottom" *ngIf="isIOSDevice" style="padding: 0px 10px;">
        <ion-col class="ion-text-left start-transform-text">
          <span [innerHTML]="data.message0"></span>
          <span [innerHTML]="data.message1"></span>
        </ion-col>
      </ion-row> -->

      <!-- <ion-row class="padding-top-bottom doubt-text" *ngIf="isIOSDevice">
        <ion-col class="ion-text-left ">
          <span [innerHTML]="data.message1"></span>
        </ion-col>
      </ion-row> -->
      <!-- https://api.whatsapp.com/send?phone=whatsappphonenumber&text=urlencodedtext -->

      <!-- <ion-row class="padding-top-bottom">
        <ion-col class="ion-text-left note-msg">
          <i>* {{data.message2}}</i>
        </ion-col>
      </ion-row> -->

      <!-- <ion-row class="ion-text-center">
        <ion-col>
          <span style="color: #d73e6d;">{{countdownTimerText}}</span>
        </ion-col>
      </ion-row> -->

      <ion-row class="ion-text-center" style="font-size: 1.5rem;" *ngIf="freeTrialEndDateDiff == 0">
        <ion-col class="ion-text-right">
          <b style="color: #01A3A4;">{{countdownHours}}</b>
        </ion-col>
        <ion-col size="1.5">
          <b style="color: #01A3A4;">:</b>
        </ion-col>
        <ion-col class="ion-text-left">
          <b style="color: #01A3A4;">{{countdownMins}}</b>
        </ion-col>
      </ion-row>

      <ion-row class="ion-text-center" *ngIf="freeTrialEndDateDiff == 0">
        <ion-col class="ion-text-right">
          <span>HRS</span>
        </ion-col>
        <ion-col size="1.5">
         
        </ion-col>
        <ion-col class="ion-text-left">
          <span>MIN</span>
        </ion-col>
      </ion-row>

      <ion-row style="margin-top:20px;">
        <ion-col size="12" class="text-center" style="border-top: 1px solid #DEB221;"></ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <ion-list style="margin-bottom:35px;">
            <ion-item lines="none">
              <span class="qa-day">Premium includes :</span>
            </ion-item>
            <div class="user-profile-item-cal text-center">
              <!-- <ion-slides [options]="slideOptsVideo" pager="true" style="margin: 15px 5px 0 5px;">
                <ion-slide *ngFor="let plan of containPlanTypes;let ing=index;">
                  <ion-card class="plan-container"
                    [ngStyle]="{'background-image':' url(' + plan.img + ')'}">
                    <div style="border-left: 5px solid;" [ngStyle]="{'border-color': plan.id == 'post_covid' ? '#754B29' : plan.id =='weightLoss' ? '#01a3a4' : plan.id =='immunity_booster' ? '#FD9F33' : plan.id =='detox' ? '#4CB271' :
                    plan.id =='diabetes' ? '#D14322' : plan.id =='cholesterol' ? '#A31E79' : plan.id =='hypertension' ? '#FF5D56' :  plan.id =='pcos' ? '#FF5A7D':
                    '#0B94C1'}" class="legend-border"></div>
                    <ion-row>
                      <ion-col class="ion-text-left ion-align-self-center " style="padding: 15px;">
                        <ion-row>
                          <div class="legend"></div>
              
                          <ion-col size="6">
                            <span class="sub-foodItem-header ">{{plan.name}}</span>
                          </ion-col>
                        </ion-row>
                      </ion-col>
                    </ion-row>

                    <ion-img src="./assets/img/recommended.svg" class="recom" *ngIf="diseases.length > 0 && isMainDiseases && ing == 0"></ion-img>
                  </ion-card>
                </ion-slide>
              </ion-slides> -->
              <ion-card class="plan-container" *ngIf="containPlanTypes.length == 0">
                <ion-skeleton-text animated class="plan-skeleton"></ion-skeleton-text>
              </ion-card>
              <div *ngIf="containPlanTypes.length > 0">
                <div *ngFor="let plan of containPlanTypes | slice:0: expandPlanCards ?  containPlanTypes.length : 3;let ing=index;">
                  <div (click)="toggelExpandCards($event,false)"
                  [ngClass]="{'expand-cards' : expandPlanCards, 'stacked-cards': !expandPlanCards && ing > -1  }" 
                  [ngStyle]="{'margin-top': !expandPlanCards && ing > -1 ? (ing * 10) +'px' : (ing * 25 + (ing *100)) +'px', 'z-index': 10 - ing,
                  'transform': !expandPlanCards && ing == 1 ? 'scale(0.95, 1)' : !expandPlanCards && ing == 2 ? 'scale(0.90, 1)' : 'none'}">
                    <div class="ion-text-end ion-padding-end show-less-txt" *ngIf="expandPlanCards && ing == 1" (click)="toggelExpandCards($event, true)">
                      <span>Show Less</span><ion-icon name="chevron-up-outline"></ion-icon>
                    </div>
                    <ion-card class="plan-container"
                      [ngStyle]="{'background-image': !expandPlanCards && (ing == 1 || ing == 2 ) ? 'none' : 'url(' + plan.img + ')'}">
                    <div style="border-left: 5px solid;" [ngStyle]="{'border-color': plan.id == 'post_covid' ? '#754B29' : plan.id =='weightLoss' ? '#01a3a4' : plan.id =='immunity_booster' ? '#FD9F33' : plan.id =='detox' ? '#4CB271' :
                    plan.id =='diabetes' ? '#D14322' : plan.id =='cholesterol' ? '#A31E79' : plan.id =='hypertension' ? '#FF5D56' :  plan.id =='pcos' ? '#FF5A7D':
                    '#0B94C1'}" class="legend-border"></div>
                      <ion-row>
                        <ion-col class="ion-text-left ion-align-self-center " style="padding: 10px 15px;">
                          <ion-row>
                            <div class="legend"></div>
                
                            <ion-col size="6">
                              <span class="sub-foodItem-header ">{{plan.name}}</span>
                            </ion-col>
                          </ion-row>
                          <ion-row style="padding-top: 5px;">
                            <ion-col size="6">
                              <span class="sub-foodItem-sub-header">{{plan.subDesc}}</span>
                              <span class="sub-foodItem-sub-header sub-foodItem-sub-header2" *ngIf="plan.subDescLine2">{{plan.subDescLine2}}</span>
                            </ion-col>
                          </ion-row>
                        </ion-col>
                      </ion-row>
                      <ion-img src="./assets/img/recommended.svg" class="recom" *ngIf="diseases.length > 0 && isMainDiseases && ing == 0"></ion-img>
                      <ion-img src="./assets/img/recommended.svg" class="recom" *ngIf="diseases.length == 0 && plan.id == 'weightLossPlus'"></ion-img>
                    </ion-card>
                  </div>
                </div>
              </div>
              
            </div>
            <div [ngStyle]="{'padding-top': !expandPlanCards ? '52%' : ''}">
              <ion-item *ngFor="let item of activitySlider; let i = index">
                <ion-thumbnail slot="start">
                  <ion-img [src]="item.image" class="plan-include-img"></ion-img>
                </ion-thumbnail>
                <ion-label>
                  <h2>{{item.title}}</h2>
                  <p>{{item.subtitle}}</p>
                </ion-label>
              </ion-item>
            </div>
          </ion-list>
        </ion-col>
      </ion-row>
      
      <ion-row class="smb-btn" *ngIf="!isIOSDevice">
        <ion-col class="ion-text-left">
          <ion-button expand="block" class="subscribe" (click)="close(true)" style="margin-top: 15px;height: 42px;">{{isIOSDevice || country != 'IND' ? 'Subscribe' : 'Pay by RazorPay'}}</ion-button>
        </ion-col>
      </ion-row>
      
      <!-- <ion-row class="padding-top-bottom doubt-text" *ngIf="!isIOSDevice" style="padding: 12px 5px 12px 10px;font-size: 1rem;">
        <ion-col class="ion-text-center" style="margin-top: 10px;">
          <i style="color: #a5a6aa;">Still in doubt ? </i>
          <a href="whatsapp://send?phone=+919999118595"> 
            <img class="whatsapp" src="./assets/images/whatsapp-icon.png" />
          </a>
        </ion-col>
      </ion-row>

      <ion-row class="padding-top-bottom doubt-text" *ngIf="isIOSDevice" style="padding: 12px 5px 12px 10px;font-size: 1rem;">
        <ion-col class="ion-text-center" style="margin-top: 10px;">
          <i style="color: #a5a6aa;">Still in doubt ? </i>
          <a href="https://api.whatsapp.com/send?phone=+919999118595"> 
            <img class="whatsapp" src="./assets/images/whatsapp-icon.png" />
          </a>
        </ion-col>
      </ion-row> -->

    </ion-card-content>
  </ion-card>
  <ion-row class="smb-btn" *ngIf="isIOSDevice">
    <ion-col></ion-col>
    <ion-col class="ion-text-left" size="10">
      <ion-button expand="block" class="subscribe" (click)="close(true)" style="margin-top: 15px;height: 42px;">{{country != 'IND' ? 'Subscribe' : 'Pay by RazorPay'}}</ion-button>
    </ion-col>
    <ion-col></ion-col>
  </ion-row>
</div>